import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportTypeSelector = ({ reportType, onChange }) => {
  const reportTypes = [
    { id: 'sales', label: 'Sales Report', icon: 'ShoppingCart', description: 'POS transactions and product sales' },
    { id: 'attendance', label: 'Attendance Report', icon: 'Users', description: 'Member check-ins and visits' },
    { id: 'revenue', label: 'Revenue Report', icon: 'DollarSign', description: 'Billing and subscription revenue' },
    { id: 'membership', label: 'Membership Report', icon: 'CreditCard', description: 'Subscription analytics' },
    { id: 'reconciliation', label: 'Reconciliation Report', icon: 'Calculator', description: 'Payment reconciliation data' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="FileText" size={18} />
        Report Type
      </h3>
      <div className="space-y-2">
        {reportTypes?.map(type => (
          <button
            key={type?.id}
            onClick={() => onChange(type?.id)}
            className={`w-full text-left p-3 rounded-lg transition-colors border ${
              reportType === type?.id
                ? 'bg-primary text-white border-primary' :'bg-background border-border hover:bg-muted'
            }`}
          >
            <div className="flex items-start gap-3">
              <Icon name={type?.icon} size={20} className={reportType === type?.id ? 'text-white' : 'text-primary'} />
              <div className="flex-1">
                <p className={`font-medium mb-1 ${reportType === type?.id ? 'text-white' : 'text-foreground'}`}>
                  {type?.label}
                </p>
                <p className={`text-xs ${reportType === type?.id ? 'text-white/80' : 'text-muted-foreground'}`}>
                  {type?.description}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReportTypeSelector;